document.addEventListener('DOMContentLoaded', function() {
  var _s = {};
  window.sliderMove = function(id, dir) {
    var track = document.getElementById('track-' + id);
    if (!track) return;
    var total = track.children.length;
    if (!_s[id]) _s[id] = 0;
    _s[id] = (_s[id] + dir + total) % total;
    track.style.transform = 'translateX(-' + (_s[id] * 100) + '%)';
  };
});

